interface GetRedirectUrlToOauthServiceParams {
  oauthUrl: string;
  actionType: 'sign-in' | 'sign-up';
  authParams: URLSearchParams | string;
}

export const getClientIdRequiredByOauthService = () => {
  return process.env.NEXT_PUBLIC_OAUTH_CLIENT_ID;
};

export const getRedirectUrlToOauthService = ({
  oauthUrl,
  actionType,
  authParams,
}: GetRedirectUrlToOauthServiceParams) => {
  return actionType === 'sign-in' ? `${oauthUrl}?${authParams}` : `${oauthUrl}/sign-up?${authParams}`;
};

export const isUserAuthenticated = (authToken: string | undefined) => {
  return (authToken ?? '').trim().length > 0;
};
